import { CommaSeparatedLinks } from '~/components/comma-separated-links';
import { Container } from '~/components/layout';
import { Text } from '~/components/typography';
import { ContractVersion } from '~/typings/context';

export type TermsTextProps = {
  contracts: ContractVersion[];
  preText?: any;
  postText?: string;
  lastConjunction?: string;
  textAlign?: 'left' | 'center';
  originationSourceType?: string;
  inReviewScreen?: boolean;
  utilityAccountId?: number;
  showPersonalizedContractPreview?: boolean;
};

export const TermsText = ({
  contracts = [],
  preText = 'I have read the',
  postText = '. By proceeding, I will be submitting my e-signature.',
  lastConjunction = ' and the ',
  textAlign = 'left',
  originationSourceType,
  inReviewScreen = false,
  utilityAccountId,
  showPersonalizedContractPreview = false,
}: TermsTextProps) => {
  if (!contracts.length) return null;
  const preTextSponsoredSolar =
    'By checking this box, I affirm that I have first and separately reviewed the';
  const middleTextSponsoredSolar =
    ' and agree to its terms and conditions. By checking this box, I also affirm that I have reviewed, read and agree to the terms and conditions of the ';
  const postTextSponsoredSolar =
    '. By checking this box, I understand and agree that my electronic signature will be applied to all of these agreements and will bind me to all Agreement terms and conditions.';
  const sponsoredSolar = originationSourceType === 'sponsored_solar';

  const contractsMap = {};
  contracts.forEach(contract => {
    contractsMap[contract.displayName] = contract;
  });

  return inReviewScreen && sponsoredSolar ? (
    <Text textStyle="paragraph400" color="secondary" textAlign={textAlign}>
      {preTextSponsoredSolar}{' '}
      <CommaSeparatedLinks
        lastConjunction={lastConjunction}
        contracts={[contractsMap['Community Solar Agency Agreement']]}
        linkProps={{ color: 'secondary' }}
        utilityAccountId={utilityAccountId}
        showPersonalizedContractPreview={showPersonalizedContractPreview}
      />
      {middleTextSponsoredSolar}
      <CommaSeparatedLinks
        lastConjunction={lastConjunction}
        contracts={[contractsMap['Disclosure form'], contractsMap['Solar Beneficiary Agreement']]}
        linkProps={{ color: 'secondary' }}
        utilityAccountId={utilityAccountId}
        showPersonalizedContractPreview={showPersonalizedContractPreview}
      />
      {postTextSponsoredSolar}
    </Text>
  ) : (
    <Container>
      <Text textStyle="paragraph400" color="secondary" textAlign={textAlign}>
        {preText}{' '}
        <CommaSeparatedLinks
          lastConjunction={lastConjunction}
          contracts={contracts}
          linkProps={{ color: 'secondary' }}
          utilityAccountId={utilityAccountId}
          showPersonalizedContractPreview={showPersonalizedContractPreview}
        />
        {postText}
      </Text>
    </Container>
  );
};
